/*
 * Planner Messages
 *
 * This contains all the text for the Planner component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.Planner.header',
    defaultMessage: 'Plan Parent Meetings',
  },
  general: {
    id: 'app.components.Planner.general',
    defaultMessage: 'General',
  },
  generalHeader: {
    id: 'app.components.Planner.generalHeader',
    defaultMessage: 'General Settings',
  },
  students: {
    id: 'app.components.Planner.students',
    defaultMessage: 'Student',
  },
  studentsHeader: {
    id: 'app.components.Planner.studentsHeader',
    defaultMessage: 'Select Students',
  },
  period: {
    id: 'app.components.Planner.period',
    defaultMessage: 'Meetings Period',
  },
  assign: {
    id: 'app.components.Planner.assign',
    defaultMessage: 'Assign Slots',
  },
  registration: {
    id: 'app.components.Planner.registration',
    defaultMessage: 'Registration Period',
  },
  meetingLocationType: {
    id: 'app.components.Planner.meetingLocationType',
    defaultMessage: 'Location',
  },
  onPremises: {
    id: 'app.components.Planner.onPremises',
    defaultMessage: 'On Premises',
  },
  videoMeeting: {
    id: 'app.components.Planner.videoMeeting',
    defaultMessage: 'Video Conference',
  },
  parentsChoose: {
    id: 'app.components.Planner.parentsChoose',
    defaultMessage: 'Parents choose',
  },
  timeslotGone: {
    id: 'app.components.MeetingsBlock.timeslotGone',
    defaultMessage: 'The time slot is not available anymore, select another slot',
  },
});
